import { lazy, Suspense } from "react";
import LoadingFeedback from "@/components/shared/loading/LoadingFeedback";

const CandidatesManagment = lazy(() =>
  import("@/features/candidatesManagment/pages/CandidatesManagment")
);

export const candidateRoutes = [
  {
    path: "/candidates-managment",
    element: (
      <Suspense fallback={<LoadingFeedback />}>
        <CandidatesManagment />
      </Suspense>
    ),
  },
];
